"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var format_price_1 = __importDefault(require("../../../utils/format-price/"));
var useContext = react_1.default.useContext;
exports.default = (function () {
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var priceDiscount = context.priceDiscount, priceSubtotal = context.priceSubtotal, priceTaxes = context.priceTaxes, priceTotal = context.priceTotal, shippingMethod = context.shippingMethod;
    return (react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
        priceDiscount && priceDiscount !== '0.00' && (react_1.default.createElement("div", { className: 'grid-x checkout-os-text margin-bottom-2' },
            react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' },
                react_1.default.createElement("b", null, "Discount")),
            react_1.default.createElement("div", { className: 'cell small-3 text-right' },
                "$",
                priceDiscount))),
        react_1.default.createElement("div", { className: 'grid-x checkout-os-text margin-bottom-2' },
            react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' }, "Subtotal"),
            react_1.default.createElement("div", { className: 'cell small-3 text-right' }, (0, format_price_1.default)(priceSubtotal === null || priceSubtotal === void 0 ? void 0 : priceSubtotal.toString()))),
        react_1.default.createElement("div", { className: 'grid-x checkout-os-text margin-bottom-2' },
            react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' }, "Shipping"),
            react_1.default.createElement("div", { className: 'cell small-3 text-right' },
                shippingMethod ? (shippingMethod.price === '0.00' ? 'FREE' : (0, format_price_1.default)(shippingMethod.price)) : '---',
                " ")),
        react_1.default.createElement("div", { className: 'grid-x checkout-os-text' },
            react_1.default.createElement("div", { className: 'cell small-9 checkout-os-text-bold' }, "Taxes"),
            react_1.default.createElement("div", { className: 'cell small-3 text-right' }, priceTaxes ? (0, format_price_1.default)(priceTaxes) : react_1.default.createElement("i", null, "---"))),
        react_1.default.createElement("div", { className: 'margin-bottom-6 margin-top-6' },
            react_1.default.createElement("div", { className: 'horizontal-divider-brownish-grey' })),
        react_1.default.createElement("div", { className: 'grid-x margin-bottom-2' },
            react_1.default.createElement("div", { className: 'cell small-9', style: { fontSize: '14px', fontWeight: 500 } },
                !priceTaxes && !shippingMethod && 'Estimated ',
                "Total"),
            react_1.default.createElement("div", { className: 'cell small-3 text-right', style: { fontSize: '14px' } }, priceTotal ? (0, format_price_1.default)(priceTotal) : react_1.default.createElement("i", null, "---")))));
});
